import styled from 'styled-components';
import { border } from 'styled-system';

import { Box } from '@hivebrite/design-system/Box';

import EventCanceledLabel from 'hb-react/shared/apps/Events/components/EventCanceledLabel';
import EventPricingTag from 'hb-react/shared/apps/Events/components/EventPricingTag';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';

// GS creates :medium preview of the picture with this width.
const GS_IMAGE_MEDIUM_WIDTH = 400;

const EventHeader = (props) => {
  const { event } = useEventContext();

  return (
    <Box flexDirection="column" position="relative" height="100%" {...props}>
      <CoverWrapper opacity={event.cancelled ? 0.4 : 1}>
        <StyledImage
          data-testid="event-cover-image"
          src={event?.new_cover_picture?.original_url}
          srcSet={`${event?.new_cover_picture?.medium_url} ${GS_IMAGE_MEDIUM_WIDTH}w, ${event?.new_cover_picture?.wide_url}`}
          sizes={`(max-width: ${GS_IMAGE_MEDIUM_WIDTH}px) ${GS_IMAGE_MEDIUM_WIDTH}px, 100vw`}
          alt=""
          // @ts-expect-error: fetchPriority is not in the types
          fetchpriority="high"
        />
      </CoverWrapper>
      <Box position="absolute" top={2} left={2}>
        {event.cancelled ? (
          <EventCanceledLabel event={event} />
        ) : (
          <EventPricingTag event={event} />
        )}
      </Box>
    </Box>
  );
};

export default EventHeader;

const CoverWrapper = styled(Box).attrs(({ theme }) => ({
  flexGrow: 1,
  height: { _: 'auto', m: '100%' },
  width: '100%',
  overflow: 'hidden',
  borderRadius: {
    _: 0,
    m: theme.themeVariables.globalBorderRadius,
  },
}))`
  ${border}
`;

const StyledImage = styled.img.withConfig({
  shouldForwardProp: () => true,
})`
  width: 100%;
  height: auto;
  min-height: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: top center;
`;
